<template>
  <div class="dynamic">
      <div class="article-box">
        <Article v-for="(item,index) in articleItems" class="infinite-list-item" :article="item" :key="index"></Article>
        <p v-if="loading" style="text-align: center;">加载中...</p>
        <p v-if="noMore" style="text-align: center;">没有更多了</p>
      </div>
      <TzFooter></TzFooter>
  </div>
</template>

<script>
  import Article from '@/components/common/Article.vue';
	import TzFooter from '@/components/common/TzFooter.vue';
  export default{
     components: {
        Article,
        TzFooter
     },
     data: function(){
       return{
         articleItems: [],
         count: 1,
         loading: false,
         noMore: false
       }
     },
     mounted() {
      //  console.log(this.TzConfig.BASE_URL)
       this.getList(this.count,10)
       this.scroll(this.count)
     },
     methods: {
       getList(page,pageSize){
          this.loading = true
          this.count++
          this.$http.get(this.TzConfig.BASE_URL+'/article/api/list',{
            params: {
              page: page,
              pageSize: pageSize
            }
          }).then(res => {
            this.loading = false
            if(res.data.data.list.length < pageSize){
              this.noMore = true
            }
            for(var i=0;i<res.data.data.list.length;i++){
              this.articleItems.push(res.data.data.list[i])
            }
          }).catch(err => {
            this.loading = false
          })
       },
       scroll() {
          window.onscroll = () => {
            if (!this.noMore){
               let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
               if (bottomOfWindow) {
                 this.getList(this.count,10);
               }
            }
          }
       }
     }
  }
</script>

<style>
  .article-box{
    width: 80%;
    max-width: 800px;
    margin: 4% auto 4%;
  }
  @media screen and (max-width: 768px) {
    .article-box{
      width: 90%;
      max-width: 800px;
      margin: 4% auto 0;
    }
  }
</style>
